import { ACCENT_CLASSES, type VacancyDef } from '../../../config/vacancies';

interface Props {
  vacancy: VacancyDef;
  onSelect: (route: string) => void;
}

export default function VacancyCard({ vacancy, onSelect }: Props) {
  const c = ACCENT_CLASSES[vacancy.accent];

  return (
    <div
      onClick={() => onSelect(vacancy.route)}
      className={`group relative bg-[#0e0e11] border ${c.border} ${c.borderHover} rounded-2xl p-10 flex flex-col items-center text-center cursor-pointer transition-all duration-300 hover:-translate-y-2`}
    >
      {vacancy.badge && (
        <div className="absolute top-4 right-4">
          <span className={`text-xs border rounded-full px-2.5 py-1 ${c.badge}`}>
            {vacancy.badge}
          </span>
        </div>
      )}

      <div
        className="w-20 h-20 flex items-center justify-center rounded-2xl mb-6 transition-all duration-300 group-hover:scale-110"
        style={{ background: c.gradient }}
      >
        <i className={`${vacancy.icon} text-4xl ${c.iconText}`} />
      </div>

      <h2 className="text-2xl font-bold text-white mb-3">{vacancy.title}</h2>
      <p className="text-foreground-500 text-sm leading-relaxed mb-8">{vacancy.description}</p>

      <button
        className={`mt-auto w-full rounded-xl py-3 text-sm transition-all duration-200 cursor-pointer whitespace-nowrap ${c.button}`}
      >
        {vacancy.buttonLabel}
      </button>
    </div>
  );
}
